import { render, staticRenderFns } from "./ModalTecnicos.vue?vue&type=template&id=2e29484a&"
import script from "./ModalTecnicos.vue?vue&type=script&lang=js&"
export * from "./ModalTecnicos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports